import { useEffect, useRef } from 'react';
import { ErrorView } from './ErrorView';
import { logError } from '@/utils/log';

interface NotFoundPageProps {
  /** Where to send the visitor instead of home, such as the blog for a missing post. */
  primaryAction?: { label: string; to: string };
}

export default function NotFoundPage({ primaryAction = { label: 'Return home', to: '/' } }: NotFoundPageProps) {
  const loggedRef = useRef(false);

  useEffect(() => {
    if (loggedRef.current) return;
    loggedRef.current = true;

    logError('not_found', new Error('Route not found'), {
      attemptedPath: window.location.pathname,
      attemptedHref: window.location.href,
    });
  }, []);

  return (
    <ErrorView
      eyebrow="404"
      title="Nothing lives here."
      message="That route doesn’t exist in Doopey's World — or it existed once and wandered off. Either way, you’ve got a clean path back home instead of a dead end."
      primaryAction={primaryAction}
      supportLink={{ to: `/bugreport?page=${encodeURIComponent(window.location.pathname)}`, label: 'Report a bug' }}
    />
  );
}
